import script from "./ModuleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleView.vue?vue&type=script&setup=true&lang=js"

import "./ModuleView.vue?vue&type=style&index=0&id=6c6da437&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6da437"]])

export default __exports__